@use "../../../../styles/colors";

:global {
  body[class*="theme-"].theme {
    :local {
      .container {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
      }
      .actionContainer {
        width: 100%;
        background-color: colors.$mmc-white;
      }

      .toolbarPopover {
        :global(.ant-popover-content) {
          :global(.ant-popover-inner) {
            border: none;
            :global(.ant-popover-inner-content) {
              padding: 0;
            }
          }
        }
      }

      .togglerButton {
        padding: 0.25rem 0.5rem;
        cursor: pointer;
      }

      span.active {
        background-color: colors.$mmc-primary-010;
        color: colors.$mmc-primary-100;
      }

      .disabledIcon {
        color: colors.$mmc-disabled-gray;
      }
      .aiWriter {
        position: relative;
        border-radius: 50%;
        background: conic-gradient(
          from 180deg at 50% 50%,
          rgba(colors.$mmc-primary-100, 0.1) 118.80000472068787deg,
          rgba(colors.$mmc-ai-cyan, 0.1) 237.60000944137573deg,
          rgba(colors.$mmc-ai-purple, 0.1) 356.40000343322754deg
        );
      }

      .aiWriterVisible {
        background: conic-gradient(
          from 180deg at 50% 50%,
          rgba(colors.$mmc-primary-100, 0.25) 118.80000472068787deg,
          rgba(colors.$mmc-ai-cyan, 0.25) 237.60000944137573deg,
          rgba(colors.$mmc-ai-purple, 0.25) 356.40000343322754deg
        );
      }
    }
  }
}
